import { combineReducers } from 'redux';
import sidebarReducer from './appSidebarReducer';

const appReducers = combineReducers({
  sidebar: sidebarReducer,
});

export default appReducers;
